export default [

     {
          path: '/requirement-type',
          name: 'RequirementType',
          component: () => import("@/views/Page/RequirementType/RequirementType.vue"),
           meta: {
               title: '#Default# | RequirementType',
          },
     }
];